// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_nz-5";
export var filledCircle = "_nz-4";
export var historyEntry = "_nz-3";
export var messageSideLeft = "_nz-1";
export var messageSideRight = "_nz-2";
export var orderTrackingCarouselWrapper = "_nz-6";
export var orderTrackingInfoContainer = "_nz-0";